import {
  queryOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { client } from "$api/client";
import { retrieveTokens } from "$api/tokenManagement";

export const getAttributeFieldQueryByKey = () =>
  queryOptions({
    queryKey: ["relevantAttributes"],
    queryFn: async () => {
      const relevantItems = await client.get("/attribute/relevant_count");
      return relevantItems?.data;
    },
  });

export const getValueFieldQueryByKey = (municipalId) =>
  queryOptions({
    queryKey: ["requiredNumOfValues"],
    queryFn: async () => {
      const relevantItems = await client.get(
        `/municipal_utility/${municipalId}/required_num_of_values`
      );
      return relevantItems?.data;
    },
  });

export const usePostField = (queryKeyValue) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body) => {
      const { municipal } = retrieveTokens();
      const { data } = await client.patch(
        `/municipal_utility/${municipal}`,
        body,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [queryKeyValue],
      });
    },
    onError: () => {
      queryClient.invalidateQueries({
        queryKey: [queryKeyValue],
      });
    },
  });
};
